<template>
  <v-container>
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-layout class="back pb-3 pt-3">
      <v-btn icon small @click="goBack()">
        <v-icon class="text--darken-1">arrow_back</v-icon>
      </v-btn>
      <v-layout align-center justify-center>
        <span class="font-weight-medium title">Abastecimento</span>
      </v-layout>
    </v-layout>

    <v-divider class="my-1"></v-divider>
    <v-layout text-start column pt-2 mb-15>
      <span class="subheading font-weight-medium pt-5 pb-5">
        Para reabastecer, utilize o cartão combustível localizado no porta-luvas
        do veículo.
      </span>

      <v-layout row class="mx-4 mt-3">
        <v-flex xs6>
          <v-layout fill-height column text-left align-start justify-center>
            <span class="subheading font-weight-medium">Senha/Matrícula:</span>
            <span
              class="blue--text text--darken-1 display-1 font-weight-medium"
              >{{ vehicleRequest.vehicle.card_password }}</span
            >
          </v-layout>
        </v-flex>
        <v-flex xs6>
          <v-layout fill-height column align-end justify-center>
            <v-img
              :src="require(`@/assets/maquina-de-cartao.png`)"
              style="width: 60%"
            ></v-img>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-flex class="text-center agreed-stations pt-6" align-end justify-center>
        <br />
        <v-btn
          text
          class="blue--text"
          style="width: 95%"
          href="https://maps.goodcard.com.br/ondecomprar/index.php?portal=ticketlog"
        >
          <span><strong>VER POSTOS CONVENIADOS</strong></span>
        </v-btn>

        <v-btn
          @click="showRefuelDialog = true"
          class="colorBtn mt-2"
          style="width: 95%"
        >
          ANEXAR COMPROVANTE
        </v-btn>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showRefuelDialog">
      <v-card>
        <v-card-title>
          <span class="headline">Comprovante de abastecimento</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <label>Local</label>
              <input
                required
                type="text"
                id="supply-slocal-input"
                v-model="supply_local"
                placeholder="Nome do local"
                class="form-control borderInput"
              />
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label>Combustível</label>
              <v-select
                id="fuel-input"
                :items="combustiveis"
                v-model="fuel_type"
                :required="!fuel_type"
                item-text="name"
                item-value="name"
                placeholder="Selecione o combustível"
                text
                dense
                outlined
                color="info"
                hide-details
              ></v-select>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label>Quantidade</label>
              <money
                required
                v-model="amount"
                v-bind="quantidadeLitros"
                class="form-control borderInput"
              ></money>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label>Valor abastecido:</label>
              <money
                required
                v-model="value"
                v-bind="money"
                class="form-control borderInput"
              ></money>
            </v-col>

            <v-col cols="12" v-if="identifyAndroid()">
              <v-btn
                large
                text
                class="agreed-posts"
                style="width: 96%"
                @click="capture()"
              >
                <span><strong>ANEXAR COMPROVANTE</strong></span>
                <label class="selectImgIcon">
                  <v-icon size="60" color="success" v-if="selectedImg"
                    >done_outline</v-icon
                  >
                </label>
              </v-btn>
            </v-col>
            <v-col v-else>
              <label for="selectFile" class="selectImgIcon">
                <v-icon>mdi-file-document-multiple-outline</v-icon>
                <span class="font-weight-bold">Anexar comprovante</span>
                <v-icon size="60" color="success" v-if="selectedImg"
                  >done_outline</v-icon
                >
              </label>
              <input
                capture="environment"
                id="selectFile"
                type="file"
                style="display: none"
                accept="image/*"
                @change="onFileSelected"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showRefuelDialog = false">
            CANCELAR
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="enviarComprovante()"
            :disabled="!selectedImg"
          >
            SALVAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <FinishRefuel
      :show="showFinishRefuel"
      @voltar="
        $router.push({
          name: 'driver-vehicle-request-dashboard',
        })
      "
    ></FinishRefuel>
  </v-container>
</template>

<script>
function cFile2Blob(cfile, cb) {
  let fr = new FileReader();
  fr.onloadend = ev => {
    let b = new Blob([ev.target.result], { type: 'image/jpeg' });
    b.name = cfile.name;
    cb(b);
  };
  fr.readAsArrayBuffer(cfile);
}
import HistoricoAbastecimentoController from './../../controllers/HistoricoAbastecimentoController';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import FinishRefuel from './FinishRefuel';
export default {
  components: {
    FinishRefuel,
  },
  data() {
    return {
      showFinishRefuel: false,
      vehicleRequestId: this.$route.params.vehicleRequestId,
      historicoAbastecimentoController: new HistoricoAbastecimentoController(
        this.$resource
      ),
      vehicleRequestController: new VehicleRequestController(this.$resource),

      supply_local: '',
      fuel_type: '',
      amount: '',
      value: '',
      invoice: '',

      data: new FormData(),
      showRefuelDialog: false,
      vehicleRequest: {},

      cardPassword: '',
      money: {
        prefix: 'R$ ',
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false,
        max: 6,
      },
      quantidadeLitros: {
        suffix: ' litros',
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: false,
        max: 6,
      },
      combustiveis: ['Gasolina', 'Álcool', 'Diesel'],
      snackbar: false,
      snackbarColor: '',
      snackbarText: '',
      selectedImg: false,
    };
  },
  async created() {
    this.vehicleRequestController.getById(this.vehicleRequestId).then(res => {
      this.vehicleRequest = res;
    });
  },
  methods: {
    alert(text, color) {
      console.log(text, color);
      this.snackbarText = text;
      this.snackbarColor = color;
      this.snackbar = true;
    },

    enviarComprovante() {
      this.data.delete('form');
      this.data.append(
        'form',
        JSON.stringify({
          supply_local: this.supply_local,
          fuel_type: this.fuel_type,
          value: this.value.toFixed(2).replace('.', ''),
          amount: this.amount.toFixed(2).replace('.', ''),
          vehicleRequest: this.vehicleRequest,
        })
      );

      this.historicoAbastecimentoController
        .refuel(this.data)
        .then(res => {
          this.alert(res.message, 'success');
          this.showRefuelDialog = false;
          this.showFinishRefuel = true;
        })
        .catch(error => {
          this.alert(error.body.message, 'error');
        });
    },

    goBack() {
      this.$router.push({ name: 'driver-vehicle-request-dashboard' });
    },

    identifyAndroid() {
      if (navigator.userAgent.match(/Android/i)) return true;
      return false;
    },

    async onFileSelected(e) {
      this.data = new FormData();
      let image = e.target.files[0];
      // compactação inicio
      const width = 100;
      const fileName = e.target.files[0].name;
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = event => {
        const img = new Image();
        img.src = event.target.result;
        try {
          const elem = document.createElement('canvas');
          const scaleFactor = width / img.width;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          const ctx = elem.getContext('2d');
          // img.width and img.height tem as dimensões originais
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob(
            blob => {
              const file = new File([blob], fileName, {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              image = file;
            },
            'image/jpeg',
            1
          );
          this.selectedImg = true;
          this.data.append('cnhImage', image);
        } catch (error) {
          console.log(error);
        }
      };
    },

    capture() {
      navigator.camera.getPicture(this.onSuccess.bind(this), () => {}, {
        quality: 50,
        destinationType: Camera.DestinationType.FILE_URI,
      });
    },

    onSuccess(imageURI) {
      this.invoice = imageURI;
      this.selectedImg = true;
      this.uploadAndroid();
    },

    async uploadAndroid() {
      this.data = new FormData();
      return new Promise(
        (resolve, reject) => {
          window.resolveLocalFileSystemURL(this.invoice, fileEntry => {
            fileEntry.file(cfile => {
              cFile2Blob(cfile, blob => {
                this.data.append('cnhImage', blob);
                resolve();
              });
            });
          });
        },
        error => {
          console.error(error);
          reject(error);
        }
      );
    },
  },
};
</script>

<style scoped>
.float {
  position: absolute;
  top: 5px;
  right: 10px;
}

.selectImgIcon {
  height: 100px;
  width: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: 70%;
  margin-top: -40px;
}

.borderInput {
  border-color: #9e9e9e;
}

.colorBtn {
  color: var(--primary-color) !important;
  background-color: var(--secondary-color) !important;
  text-decoration: none;
  text-transform: none;
}

.invertedColorBtn {
  background-color: var(--primary-color) !important;
  color: var(--secondary-color) !important;
  text-decoration: none;
  text-transform: none;
}
</style>
